import { render, staticRenderFns } from "./qualifications.vue?vue&type=template&id=c5529cc6&scoped=true"
import script from "./qualifications.vue?vue&type=script&lang=js"
export * from "./qualifications.vue?vue&type=script&lang=js"
import style0 from "./qualifications.vue?vue&type=style&index=0&id=c5529cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5529cc6",
  null
  
)

export default component.exports